"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMneConfig = void 0;
const providers_1 = require("@mne-core/providers");
const labels_1 = require("../../config/labels");
const RESOURCES_PACKAGE_VERSION = "1.10.0";
const getMneConfig = (user, locale) => ({
    isBeta: true,
    items: [
        {
            kind: "logo",
            href: "dashboard",
            requiredPermission: null,
            label: (0, labels_1.getLabels)(locale).LOGO_ALT_MNE,
            large: { imgSrc: (0, providers_1.toStaticUrl)(`resources/versions/${RESOURCES_PACKAGE_VERSION}/images/argus-logo-light.svg`) },
            mini: { imgSrc: (0, providers_1.toStaticUrl)(`resources/versions/${RESOURCES_PACKAGE_VERSION}/images/argus-logo-light-mini.svg`) },
        },
        {
            kind: "user",
            label: user?.name,
            requiredPermission: null,
            imgSrc: (0, providers_1.toApiUrl)(`/users/v2/user/${user?.id}/picture`),
            items: [
                {
                    kind: "link",
                    variant: "internal",
                    label: "User settings",
                    requiredPermission: null,
                    href: "user/profile",
                },
                {
                    kind: "link",
                    variant: "external",
                    label: "API documentation",
                    requiredPermission: null,
                    href: "https://docs.mnemonic.no/",
                },
                {
                    kind: "link",
                    variant: "internal",
                    label: "Logout",
                    requiredPermission: null,
                    href: "authentication/logout",
                },
            ],
        },
        {
            kind: "search",
            label: "search",
            requiredPermission: "showLogsMenu",
        },
        {
            kind: "category",
            requiredPermission: null,
            label: (0, labels_1.getLabels)(locale).SERVICE_PAGES,
            items: [
                {
                    kind: "link",
                    label: (0, labels_1.getLabels)(locale).DASHBOARD,
                    requiredPermission: null,
                    variant: "internal",
                    iconId: "dashboard",
                    href: "dashboard/redirect",
                },
                {
                    kind: "link",
                    label: (0, labels_1.getLabels)(locale).REALTIME,
                    requiredPermission: "realtimeDesktop",
                    variant: "internal",
                    iconId: "realtimeBeta",
                    href: "event/realtime",
                },
                {
                    kind: "group",
                    label: (0, labels_1.getLabels)(locale).CASE,
                    iconId: "caseBeta",
                    requiredPermission: null,
                    items: [
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).CASE_CREATE_BETA,
                            requiredPermission: "useCreateCaseSPA",
                            href: "case/create",
                        },
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).CASE_SEARCH,
                            requiredPermission: "showCasePage",
                            href: "case",
                        },
                    ],
                },
                {
                    kind: "group",
                    label: (0, labels_1.getLabels)(locale).DOCUMENTS,
                    iconId: "document",
                    requiredPermission: "showReportMenu",
                    items: [
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).ROOT_FOLDER,
                            requiredPermission: "viewDocuments",
                            href: "document",
                        },
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).REPORTS,
                            requiredPermission: null,
                            href: "document/folder/byPath/Reports",
                        },
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).SERVICE_HANDBOOK,
                            requiredPermission: null,
                            href: "document/folder/byPath/Service%20Handbook",
                        },
                    ],
                },
                {
                    kind: "group",
                    label: (0, labels_1.getLabels)(locale).ASSETS,
                    iconId: "asset",
                    requiredPermission: null,
                    items: [
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).DASHBOARD,
                            requiredPermission: "showAssetPage",
                            href: "dashboard/assetMonitoring",
                        },
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).ASSETS_SEARCH,
                            requiredPermission: "showAssetPage",
                            href: "asset/assets/",
                        },
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).GROUPS,
                            requiredPermission: "showAssetPage",
                            href: "asset/groups",
                        },
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).OBSERVATIONS,
                            requiredPermission: "showAssetPage",
                            href: "asset/observations",
                        },
                        {
                            kind: "link",
                            variant: "external",
                            label: (0, labels_1.getLabels)(locale).FEEDBACK,
                            requiredPermission: "showAssetPage",
                            href: "mailto:argus-feedback@mnemonic.io",
                        },
                    ],
                },
                {
                    kind: "link",
                    variant: "internal",
                    label: (0, labels_1.getLabels)(locale).EXT_APPS,
                    iconId: "externalAppBeta",
                    requiredPermission: null,
                    href: "authentication/oauth/clients",
                },
            ],
        },
        {
            kind: "category",
            requiredPermission: null,
            label: (0, labels_1.getLabels)(locale).DATA_INSIGHT,
            items: [
                {
                    kind: "link",
                    variant: "internal",
                    label: (0, labels_1.getLabels)(locale).EVENT_SEARCH,
                    iconId: "eventSearch",
                    requiredPermission: "showEventPage",
                    href: "event/search/basic",
                },
                {
                    kind: "link",
                    variant: "internal",
                    label: (0, labels_1.getLabels)(locale).SAMPLE_DB,
                    iconId: "sample",
                    requiredPermission: "showSamplePage",
                    href: "sample/search",
                },
                {
                    kind: "link",
                    variant: "internal",
                    label: (0, labels_1.getLabels)(locale).PDNS_BETA,
                    iconId: "pdns",
                    requiredPermission: "showPassiveDNSPage",
                    href: "passivedns/search",
                },
                {
                    kind: "link",
                    variant: "internal",
                    label: (0, labels_1.getLabels)(locale).REPUTATION_SEARCH,
                    iconId: "reputationSearch",
                    requiredPermission: "viewObservationData",
                    href: "reputation/observations",
                },
                {
                    kind: "link",
                    variant: "internal",
                    label: (0, labels_1.getLabels)(locale).TI,
                    iconId: "act",
                    requiredPermission: "viewThreatIntelFact",
                    href: "act",
                },
            ],
        },
        {
            kind: "category",
            requiredPermission: null,
            label: (0, labels_1.getLabels)(locale).ADMIN_PAGES,
            items: [
                {
                    kind: "group",
                    iconId: "customer",
                    label: (0, labels_1.getLabels)(locale).CUSTOMER_PAGES,
                    requiredPermission: null,
                    items: [
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).CUSTOMERS,
                            requiredPermission: "showCustomerAdminPage",
                            href: "customer/search",
                        },
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).CUSTOMERS_NETWORK,
                            requiredPermission: "showCustomerNetworkPage",
                            href: "customernetwork",
                        },
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).CUSTOMERS_DOMAIN,
                            requiredPermission: "showCustomerDomainPage",
                            href: "customernetwork/domain",
                        },
                    ],
                },
                {
                    kind: "group",
                    iconId: "user",
                    label: (0, labels_1.getLabels)(locale).USER_MANAGEMENT,
                    requiredPermission: null,
                    items: [
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).USERS,
                            requiredPermission: "showUserAdminPage",
                            href: "user/admin/redirect",
                        },
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).PERMISSIONS,
                            requiredPermission: "viewPermissions",
                            href: "user/permission",
                        },
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).FUNCTIONS,
                            requiredPermission: "showFunctionAdminPage",
                            href: "user/function/search",
                        },
                    ],
                },
                {
                    kind: "group",
                    iconId: "event",
                    label: (0, labels_1.getLabels)(locale).EVENT_MANAGEMENT,
                    requiredPermission: null,
                    items: [
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).EVENT_FILTER,
                            requiredPermission: "viewEventFilter",
                            href: "eventfilter",
                        },
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).DATASTORE,
                            requiredPermission: "showDataStorePage",
                            href: "datastore",
                        },
                    ],
                },
                {
                    kind: "group",
                    iconId: "reputation",
                    label: (0, labels_1.getLabels)(locale).REPUTATION,
                    requiredPermission: null,
                    items: [
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).SOURCES,
                            requiredPermission: "viewOverrideData",
                            href: "reputation/sources",
                        },
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).ROLES,
                            requiredPermission: "viewOverrideData",
                            href: "reputation/roles",
                        },
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).OVERRIDES,
                            requiredPermission: "viewOverrideData",
                            href: "reputation/overrides",
                        },
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).OVERRIDE_LIST,
                            requiredPermission: "viewOverrideData",
                            href: "reputation/overridelists",
                        },
                    ],
                },
                {
                    kind: "group",
                    iconId: "component",
                    label: (0, labels_1.getLabels)(locale).COMPONENTS,
                    requiredPermission: null,
                    items: [
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).COMPONENTS_MONITOR,
                            requiredPermission: "showComponentMonitorPage",
                            href: "distributed/monitor",
                        },
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).COMPONENTS_HOSTS,
                            requiredPermission: "showConfigurationPage",
                            href: "distributed/host",
                        },
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).COMPONENTS_TEMPLATES,
                            requiredPermission: "showConfigurationPage",
                            href: "distributed/template",
                        },
                    ],
                },
                {
                    kind: "group",
                    iconId: "sensor",
                    label: (0, labels_1.getLabels)(locale).SENSOR,
                    requiredPermission: null,
                    items: [
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).SENSOR_LIST,
                            requiredPermission: "viewSensors",
                            href: "sensor/search",
                        },
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).SENSOR_STATUS,
                            requiredPermission: "viewSensorStatus",
                            href: "sensor/status",
                        },
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).LOCATIONS,
                            requiredPermission: "viewLocations",
                            href: "sensor/locations/search",
                        },
                    ],
                },
                {
                    kind: "link",
                    variant: "internal",
                    iconId: "alarm",
                    label: (0, labels_1.getLabels)(locale).ALARM_BROWSER,
                    requiredPermission: "alarmBrowser",
                    href: "alarm",
                },
            ],
        },
    ],
});
exports.getMneConfig = getMneConfig;
